import { useAppSelector } from "hooks/reduxHook";
import { getUser } from "store/ducks/investor/slice";

export const useAuthUser = () => useAppSelector(getUser);

export const useAuthPermissions = () => useAuthUser()?.permissions ?? [];
